import React from 'react';
import ProviderFieldInput from './ProviderFieldInput';

interface Props {
  cfAuthMode: 'user' | 'account';
  setCfAuthMode: (mode: 'user' | 'account') => void;
  apiToken: string;
  onTokenChange: (value: string) => void;
  error?: string;
}

const CloudflareAuthConfig: React.FC<Props> = ({
  cfAuthMode,
  setCfAuthMode,
  apiToken,
  onTokenChange,
  error,
}) => {
  const tokenField = {
    key: 'api_token',
    label: 'API Token',
    type: 'password' as const,
    required: true,
    help: cfAuthMode === 'user'
      ? 'User API Token with required scopes'
      : 'Account API Token with required scopes',
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Authentication Type
        </label>
        <select
          value={cfAuthMode}
          onChange={(e) => setCfAuthMode(e.target.value as 'user' | 'account')}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white border-gray-300 dark:border-gray-600"
        >
          <option value="user">User API Token</option>
          <option value="account">Account API Token</option>
        </select>
      </div>

      <ProviderFieldInput
        field={tokenField}
        value={apiToken}
        onChange={onTokenChange}
        error={error}
      />
    </div>
  );
};

export default CloudflareAuthConfig;